import moment from "moment-business-days";
import constants from "../constants";
import dateUtils from "../dateUtils";
import errorMessageFilter from "../filters/errorMessageFilter";
import categoryService from "./categoryService";
import categoryViewService from "./categoryViewService";
import h from "./h";
import hcCaseCommandsService from "./hcCaseCommandsService";
import hcCaseDieuXeService from "./hcCaseDieuXeService";
import hcCasePhongHopService from "./phonghop/hcCasePhongHopService";
import utils from "./utils";

export default {
  getRoomTypeLabel(type) {
    switch (type) {
      case constants.HC_CFG_MEETING_ROOM.TYPE.NORMAL:
        return errorMessageFilter({errorCode: "meetingRoom.type.normal"});
      case constants.HC_CFG_MEETING_ROOM.TYPE.ONLINE_MOBIMEETING_CODINH:
        return errorMessageFilter({
          errorCode: "meetingRoom.type.mobimeetingCoDinh"
        });
      default:
        return null;
    }
  },

  initMeetingTypeOptions() {
    return [
      {
        id: constants.HC_CASE_CALENDAR.MEETING_TYPE.OFFLINE,
        label: errorMessageFilter({
          errorCode: "hcCaseCalendar.meetingType.offline.label"
        })
      },
      {
        id: constants.HC_CASE_CALENDAR.MEETING_TYPE.ONLINE_OTHER,
        label: errorMessageFilter({
          errorCode: "hcCaseCalendar.meetingType.online.other"
        })
      }
    ];
  },

  getMeetingPlaceLabel(hcCaseCalendar, hcCfgMeetingRoom) {
    switch (hcCaseCalendar.meetingType) {
      case constants.HC_CASE_CALENDAR.MEETING_TYPE.OFFLINE:
      case constants.HC_CASE_CALENDAR.MEETING_TYPE.ONLINE_OTHER:
        return hcCaseCalendar.meetingPlace;
      case constants.HC_CASE_CALENDAR.MEETING_TYPE.ONLINE:
        return errorMessageFilter({
          errorCode: "hcCaseCalendar.meetingPlace.online.label"
        });
      case constants.HC_CASE_CALENDAR.MEETING_TYPE.ONLINE_MOBIMEETING_CODINH:
        return hcCfgMeetingRoom
          ? errorMessageFilter({
            errorCode: "hcCaseCalendar.meetingPlace.mobimeetingCoDinh.label",
            params: [hcCfgMeetingRoom.roomName]
          })
          : null;
      default:
        return hcCaseCalendar.meetingPlace;
    }
  },

  isMeetingOnline(hcCaseCalendar) {
    return (
      hcCaseCalendar &&
      hcCaseCalendar.meetingType ===
      constants.HC_CASE_CALENDAR.MEETING_TYPE.ONLINE
    );
  },

  buildHcCaseCalendarInfo(hcCaseCalendar) {
    let startTime = moment(hcCaseCalendar.startTime).format("DD/MM/YYYY HH:mm");
    let endTime = moment(hcCaseCalendar.endTime).format("DD/MM/YYYY HH:mm");
    return `${hcCaseCalendar.meetingTitle} lúc ${startTime} đến ${endTime}`;
  },

  getHcCommandSectorName(sectorId, sectorCategories) {
    // switch (sectorId) {
    //   case constants.HC_CASE_COMMANDS.SECTOR.KINHDOANH:
    //     return "Kinh doanh";
    //   case constants.HC_CASE_COMMANDS.SECTOR.KITHUATDAUTU:
    //     return "Kỹ thuật - Đầu tư";
    //   case constants.HC_CASE_COMMANDS.SECTOR.QUANLYCHUNG:
    //     return "Quản lý chung";
    //   default:
    //     return "";
    // }
    let category = h.find(
      sectorCategories,
      category => category.categoryCode === sectorId
    );
    return category ? category.categoryName : "";
  },

  getHcCommandProgressName(value) {
    switch (value) {
      case constants.HC_CASE_COMMANDS.PROGRESS.ON_TIME:
        return "Đúng hạn";
      case constants.HC_CASE_COMMANDS.PROGRESS.LATE:
        return "Chậm tiến độ";
      default:
        return "";
    }
  },

  getHcCommandStatusName(value) {
    switch (value) {
      case constants.HC_CASE_COMMANDS.STATUS.DANGXULY:
        return "Đang xử lý";
      case constants.HC_CASE_COMMANDS.STATUS.HOANTHANH:
        return "Hoàn thành";
      case constants.HC_CASE_COMMANDS.STATUS.USUALLY:
        return "Công việc thường xuyên";
      default:
        return "";
    }
  },

  getHcCommandStateName(value) {
    switch (value) {
      case constants.HC_STATE.STATE_CODE.CHI_DAO.DANG_THUC_HIEN:
        return "Đang thực hiện";
      case constants.HC_STATE.STATE_CODE.CHI_DAO.CHO_PHE_DUYET_HOAN_THANH:
        return "Chờ phê duyệt";
      case constants.HC_STATE.STATE_CODE.CHI_DAO.HOAN_THANH:
        return "Hoàn thành";
      case constants.HC_STATE.STATE_CODE.CHI_DAO.HUY_CHI_DAO:
        return "Hủy";
      case constants.HC_STATE.STATE_CODE.CHI_DAO.TRUNG_CHI_DAO:
        return "Trùng chỉ đạo";
      default:
        return "";
    }
  },

  getHcCommandProcessTypeLabel(value) {
    switch (value) {
      case constants.HC_CASE_COMMANDS.PROCESS_TYPE.CHU_TRI:
        return "Chủ trì";
      case constants.HC_CASE_COMMANDS.PROCESS_TYPE.PHOI_HOP:
        return "Phối hợp";
      default:
        return "";
    }
  },

  getHcCommandStatusLabel(commandStatus) {
    switch (commandStatus) {
      case constants.HC_CASE_COMMANDS.COMMAND_STATUS.COMPLETE:
        return "Hoàn thành";
      case constants.HC_CASE_COMMANDS.COMMAND_STATUS.PROCESSING:
        return "Đang xử lý";
      case constants.HC_CASE_COMMANDS.COMMAND_STATUS.USUALLY:
        return "Công việc hằng ngày";
      default:
        return "";
    }
  },

  async buildHcCommandSectorOptions() {
    let sectorCategories = await categoryViewService
      .findAllByGroupCode(constants.CATEGORY_GROUP_CODE.HC_COMMAND_SECTOR)
      .then(response => response.data);
    return h.collect(sectorCategories, category => {
      return {
        id: category.categoryCode,
        name: this.getHcCommandSectorName(
          category.categoryCode,
          sectorCategories
        )
      };
    });
  },

  buildHcCommandStatusOptions() {
    return h.collect(
      [
        constants.HC_CASE_COMMANDS.COMMAND_STATUS.COMPLETE,
        constants.HC_CASE_COMMANDS.COMMAND_STATUS.PROCESSING,
        constants.HC_CASE_COMMANDS.COMMAND_STATUS.USUALLY
      ],
      commandStatus => {
        return {
          id: commandStatus,
          name: this.getHcCommandStatusLabel(commandStatus)
        };
      }
    );
  },

  getActionLogActionNameLabel(actionName) {
    switch (actionName) {
      case constants.ACTION_LOG_ACTION_NAME.CHI_DAO.TAO_MOI:
        return "Tạo mới chỉ đạo";
      case constants.ACTION_LOG_ACTION_NAME.CHI_DAO.YEU_CAU_BO_SUNG:
        return "Yêu cầu bổ sung";
      case constants.ACTION_LOG_ACTION_NAME.CHI_DAO.PHE_DUYET:
        return "Phê duyệt";
      case constants.ACTION_LOG_ACTION_NAME.CHI_DAO.BAO_CAO_TIEN_DO:
        return "Báo cáo tiến độ";
      case constants.ACTION_LOG_ACTION_NAME.CHI_DAO.BAO_CAO_HOAN_THANH:
        return "Báo cáo hoàn thành";
      case constants.ACTION_LOG_ACTION_NAME.CHI_DAO.CAP_NHAT:
        return "Cập nhật chỉ đạo";
      case constants.ACTION_LOG_ACTION_NAME.CHI_DAO.GIA_HAN:
        return "Xin gia hạn chỉ đạo";
      case constants.ACTION_LOG_ACTION_NAME.CHI_DAO.DANG_KY_DEADLINE:
        return "Đăng ký hạn hoàn thành";
      case constants.ACTION_LOG_ACTION_NAME.CHI_DAO.HUY_YEU_CAU:
        return "Hủy báo cáo";
      case constants.ACTION_LOG_ACTION_NAME.CHI_DAO.BAO_TRUNG_CHI_DAO:
        return "Báo trùng chỉ đạo";
      case constants.ACTION_LOG_ACTION_NAME.CHI_DAO.CHO_Y_KIEN:
        return "Cho ý kiến chỉ đạo";
    }
  },

  getNotifyActionNameByNotifyMessageType(messageType) {
    switch (messageType) {
      case constants.VB_NOTIFICATION.MESSAGE_TYPE.CHI_DAO.BAO_CAO:
        return "Báo cáo";
      case constants.VB_NOTIFICATION.MESSAGE_TYPE.CHI_DAO.GIA_HAN:
        return "Gia hạn";
      case constants.VB_NOTIFICATION.MESSAGE_TYPE.CHI_DAO.CREATE:
        return "Tạo mới";
      case constants.VB_NOTIFICATION.MESSAGE_TYPE.CHI_DAO.UPDATE:
        return "Cập nhật";
      case constants.VB_NOTIFICATION.MESSAGE_TYPE.CHI_DAO.PHE_DUYET:
        return "Phê duyệt";
      case constants.VB_NOTIFICATION.MESSAGE_TYPE.CHI_DAO.HUY:
        return "Hủy";
      case constants.VB_NOTIFICATION.MESSAGE_TYPE.CHI_DAO.YCBS:
        return "Yêu cầu bổ sung";
      case constants.VB_NOTIFICATION.MESSAGE_TYPE.CHI_DAO.DK_DEADLINE:
        return "Đăng ký hạn hoàn thành";
      case constants.VB_NOTIFICATION.MESSAGE_TYPE.CHI_DAO.CHO_Y_KIEN:
        return "Cho YK chỉ đạo";

      //  dieu xe;
      case constants.VB_NOTIFICATION.MESSAGE_TYPE.DIEU_XE.CAP_NHAT:
        return "Cập nhật";
      case constants.VB_NOTIFICATION.MESSAGE_TYPE.DIEU_XE.HUY_YEU_CAU:
        return "Hủy";
      case constants.VB_NOTIFICATION.MESSAGE_TYPE.DIEU_XE.TU_CHOI:
        return "Từ chối";
      case constants.VB_NOTIFICATION.MESSAGE_TYPE.DIEU_XE.PHE_DUYET:
        return "Phê duyệt";
      case constants.VB_NOTIFICATION.MESSAGE_TYPE.DIEU_XE.DANG_KY:
        return "Đăng ký";

      //  may bay;
      case constants.VB_NOTIFICATION.MESSAGE_TYPE.MAY_BAY.CAP_NHAT:
        return "Cập nhật";
      case constants.VB_NOTIFICATION.MESSAGE_TYPE.MAY_BAY.HUY_YEU_CAU:
        return "Hủy";
      case constants.VB_NOTIFICATION.MESSAGE_TYPE.MAY_BAY.TU_CHOI:
        return "Từ chối";
      case constants.VB_NOTIFICATION.MESSAGE_TYPE.MAY_BAY.PHE_DUYET:
        return "Phê duyệt";
      case constants.VB_NOTIFICATION.MESSAGE_TYPE.MAY_BAY.DANG_KY:
        return "Đăng ký";

      //  khach san;
      case constants.VB_NOTIFICATION.MESSAGE_TYPE.KHACH_SAN.CAP_NHAT:
      case constants.VB_NOTIFICATION.MESSAGE_TYPE.PHONG_HOP.CAP_NHAT:
        return "Cập nhật";
      case constants.VB_NOTIFICATION.MESSAGE_TYPE.KHACH_SAN.HUY_YEU_CAU:
      case constants.VB_NOTIFICATION.MESSAGE_TYPE.PHONG_HOP.HUY_YEU_CAU:
        return "Hủy";
      case constants.VB_NOTIFICATION.MESSAGE_TYPE.KHACH_SAN.TU_CHOI:
      case constants.VB_NOTIFICATION.MESSAGE_TYPE.PHONG_HOP.TU_CHOI:
        return "Từ chối";
      case constants.VB_NOTIFICATION.MESSAGE_TYPE.KHACH_SAN.PHE_DUYET:
      case constants.VB_NOTIFICATION.MESSAGE_TYPE.PHONG_HOP.PHE_DUYET:
        return "Phê duyệt";
      case constants.VB_NOTIFICATION.MESSAGE_TYPE.KHACH_SAN.DANG_KY:
      case constants.VB_NOTIFICATION.MESSAGE_TYPE.PHONG_HOP.DANG_KY:
        return "Đăng ký";

      //  sua chua nho;
      case constants.VB_NOTIFICATION.MESSAGE_TYPE.SUA_CHUA_NHO.CAP_NHAT:
        return "Cập nhật";
      case constants.VB_NOTIFICATION.MESSAGE_TYPE.SUA_CHUA_NHO.HUY_YEU_CAU:
        return "Hủy";
      case constants.VB_NOTIFICATION.MESSAGE_TYPE.SUA_CHUA_NHO.TU_CHOI:
        return "Từ chối";
      case constants.VB_NOTIFICATION.MESSAGE_TYPE.SUA_CHUA_NHO.PHE_DUYET:
        return "Phê duyệt";
      case constants.VB_NOTIFICATION.MESSAGE_TYPE.SUA_CHUA_NHO.DANG_KY:
        return "Đăng ký";

      default:
        return this.vbNotificationView.messageType;
    }
  },

  viewHcCommandsDetail(route, router, hcCommandsId) {
    return hcCaseCommandsService.findById(hcCommandsId).then(response => {
      let params = utils.merge(route.params, {
        id: response.data.hcCaseMasterId
      });
      router.push({
        name: "adminstration-concludeDetail",
        params: params
      });
    });
  },

  viewHcDieuXeDetail(route, router, hcCaseDieuXeId) {
    return hcCaseDieuXeService.findById(hcCaseDieuXeId).then(response => {
      let params = utils.merge(route.params, {
        id: response.data.hcCaseMasterId
      });
      router.push({
        name: "adminstration-getCarDetail",
        params: params
      });
    });
  },

  viewHcCasePhongHopDetail(route, router, id, userDeptRoleId) {
    return hcCasePhongHopService.findById(id).then(response => {
      let params = utils.merge(route.params, {
        id: response.data.caseMasterId,
        userDeptRoleId: userDeptRoleId
      });
      router.push({
        name: "adminstration-detail",
        params: params
      });
    });
  },

  sortHcDocRelations(oldHcDocRelations) {
    return oldHcDocRelations.sort((item1, item2) => {
      let createTime1 = new Date(item1.createTime);
      let createTime2 = new Date(item2.createTime);
      let compareResult = createTime1.getTime() - createTime2.getTime();
      return compareResult !== 0
        ? compareResult
        : item1.id.localeCompare(item2.id);
    });
  },

  isDiffHcDocRelation(hcDocRelation, oldHcDocRelation) {
    return (
      hcDocRelation.id !== oldHcDocRelation.id ||
      hcDocRelation.referenceObjectId !== oldHcDocRelation.referenceObjectId ||
      hcDocRelation.quote !== oldHcDocRelation.quote ||
      hcDocRelation.docCode !== oldHcDocRelation.docCode ||
      hcDocRelation.docDate !== oldHcDocRelation.docDate
    );
  },

  isDiffHcDocRelations(hcDocRelations, oldHcDocRelations) {
    if (hcDocRelations.length !== oldHcDocRelations.length) return true;
    return h.exists(hcDocRelations, (hcDocRelation, index) => {
      let oldHcDocRelation = oldHcDocRelations[index];
      return this.isDiffHcDocRelation(hcDocRelation, oldHcDocRelation);
    });
  },

  buildHcDocRelationsLabel(hcDocRelations) {
    return (
      h.collect(hcDocRelations, hcDocRelation => {
        return [
          hcDocRelation.quote || "-",
          hcDocRelation.docCode || "-",
          this.formatDate(hcDocRelation.docDate) || "-"
        ].join(" | ");
      }) || []
    )
      .join("\n")
      .trim();
  },

  populateValueChangeLogsForHcDocRelations(
    property,
    oldHcDocRelations,
    hcDocRelations,
    valueChangeLogs,
    propertyLabel
  ) {
    oldHcDocRelations = this.sortHcDocRelations(oldHcDocRelations);
    hcDocRelations = this.sortHcDocRelations(hcDocRelations);

    if (this.isDiffHcDocRelations(hcDocRelations, oldHcDocRelations)) {
      valueChangeLogs.push({
        property: property,
        propertyLabel: propertyLabel,
        oldValue: this.buildHcDocRelationsLabel(oldHcDocRelations),
        newValue: this.buildHcDocRelationsLabel(hcDocRelations)
      });
    }
  },

  formatDate(value) {
    return utils.formatDateForDisplayActionLog(value);
  },

  buildDieuXeRequestTypeOptions() {
    return h.collect(
      [
        constants.HC_CASE_DIEUXE.REQUEST_TYPE.NOITHANH,
        constants.HC_CASE_DIEUXE.REQUEST_TYPE.LIENTINH
      ],
      requestType => {
        return {
          id: requestType,
          name: this.getDieuXeRequestTypeLabel(requestType)
        };
      }
    );
  },

  getDieuXeRequestTypeLabel(requestType) {
    switch (requestType) {
      case constants.HC_CASE_DIEUXE.REQUEST_TYPE.NOITHANH:
        return "Nội thành";
      case constants.HC_CASE_DIEUXE.REQUEST_TYPE.LIENTINH:
        return "Liên tỉnh";
      default:
        return "";
    }
  },

  getDieuXeStateLabel(state) {
    switch (state) {
      case constants.HC_STATE.STATE_CODE.DIEU_XE.DA_DANG_KY:
        return "Đã đăng ký";
      case constants.HC_STATE.STATE_CODE.DIEU_XE.CHO_PHE_DUYET:
        return "Chờ phê duyệt";
      case constants.HC_STATE.STATE_CODE.DIEU_XE.DA_PHE_DUYET:
        return "Đã phê duyệt";
      case constants.HC_STATE.STATE_CODE.DIEU_XE.TU_CHOI:
        return "Từ chối";
      case constants.HC_STATE.STATE_CODE.DIEU_XE.HUY:
        return "Hủy";
      default:
        return "";
    }
  },

  getMayBayStateLabel(state) {
    switch (state) {
      case constants.HC_STATE.STATE_CODE.MAY_BAY.DA_DANG_KY:
        return "Đã đăng ký";
      case constants.HC_STATE.STATE_CODE.MAY_BAY.CHO_PHE_DUYET:
        return "Chờ phê duyệt";
      case constants.HC_STATE.STATE_CODE.MAY_BAY.DA_PHE_DUYET:
        return "Đã phê duyệt";
      case constants.HC_STATE.STATE_CODE.MAY_BAY.TU_CHOI:
        return "Đã từ chối";
      case constants.HC_STATE.STATE_CODE.MAY_BAY.HUY:
        return "Hủy";
      default:
        return "";
    }
  },

  sortHcCfgDrivers(drivers) {
    return (drivers || []).sort((item1, item2) => {
      let name1 = utils.getFirstName(item1.fullName) || "";
      let name2 = utils.getFirstName(item2.fullName) || "";
      return name1.localeCompare(name2);
    });
  },

  getHcGenderLabel(gender) {
    switch (gender) {
      case constants.HC_CASE_FLIGHT_USER.GENDER.MALE:
        return "Nam";
      case constants.HC_CASE_FLIGHT_USER.GENDER.FEMALE:
        return "Nữ";
      default:
        return "";
    }
  },

  initHcCaseFlightFilesFieldTitle(hcCaseFlightFileType) {
    switch (hcCaseFlightFileType) {
      case constants.HC_CASE_FLIGHT_FILE.TYPE.TO_TRINH:
      case constants.HC_CASE_FLIGHT_FILE.TYPE.KHACH_SAN.TO_TRINH:
        return "Tệp tờ trình";
      case constants.HC_CASE_FLIGHT_FILE.TYPE.VE_MAY_BAY:
        return "Vé máy bay";
      case constants.HC_CASE_FLIGHT_FILE.TYPE.KHACH_SAN.VE_KHACH_SAN:
        return "Giấy tờ khách sạn";
      default:
        return "";
    }
  },

  initMayBayFileValidateFileOptions(type) {
    switch (type) {
      case constants.HC_CASE_FLIGHT_FILE.TYPE.VE_MAY_BAY:
      case constants.HC_CASE_FLIGHT_FILE.TYPE.KHACH_SAN.VE_KHACH_SAN:
        return {
          acceptFileTypes: ["application/pdf", "image/png", "image/jpeg"]
        };
      case constants.HC_CASE_FLIGHT_FILE.TYPE.TO_TRINH:
      case constants.HC_CASE_FLIGHT_FILE.TYPE.KHACH_SAN.TO_TRINH:
        return {
          acceptFileTypes: ["application/pdf"]
        };
      default:
        return null;
    }
  },

  getVbAttachmentObjectTypeByHcCaseFlightFileType(hcCaseFlightFileType) {
    switch (hcCaseFlightFileType) {
      case constants.HC_CASE_FLIGHT_FILE.TYPE.TO_TRINH:
        return constants.ATTACHMENT_OBJECT_TYPE.TOTRINH_VEMAYBAY;
      case constants.HC_CASE_FLIGHT_FILE.TYPE.VE_MAY_BAY:
        return constants.ATTACHMENT_OBJECT_TYPE.VEMAYBAY;
      case constants.HC_CASE_FLIGHT_FILE.TYPE.KHACH_SAN.TO_TRINH:
        return constants.ATTACHMENT_OBJECT_TYPE.TOTRINH_KHACHSAN;
      case constants.HC_CASE_FLIGHT_FILE.TYPE.KHACH_SAN.VE_KHACH_SAN:
        return constants.ATTACHMENT_OBJECT_TYPE.KHACHSAN;
      default:
        return null;
    }
  },

  loadHotelLocations() {
    return categoryService
      .findAllByCategoryGroupCode(
        constants.CATEGORY_GROUP_CODE.HC_HOTEL_LOCATION
      )
      .then(response => response.data);
  },

  loadHotels() {
    return categoryService
      .findAllByCategoryGroupCode(constants.CATEGORY_GROUP_CODE.HC_HOTEL_HOTEL)
      .then(response => response.data);
  },

  isRequester(actor, baseHcCase) {
    return (
      actor &&
      baseHcCase &&
      actor.userId === baseHcCase.requestUserId &&
      actor.roleId === baseHcCase.requestRoleId &&
      actor.deptId === baseHcCase.requestDeptId
    );
  },

  getPhongHopCriticalLevelLabel(criticalLevel) {
    switch (criticalLevel) {
      case constants.HC_CASE_PHONGHOP.CRITICAL_LEVEL.QUAN_TRONG:
        return "Quan trọng";
      case constants.HC_CASE_PHONGHOP.CRITICAL_LEVEL.CO_LANH_DAO:
        return "Có lãnh đạo";
      case constants.HC_CASE_PHONGHOP.CRITICAL_LEVEL.KHONG_LANH_DAO:
        return "Không có lãnh đạo";
      default:
        return "";
    }
  },

  buildPhongHopCriticalLevelOptions() {
    return h.collect(
      [
        constants.HC_CASE_PHONGHOP.CRITICAL_LEVEL.QUAN_TRONG,
        constants.HC_CASE_PHONGHOP.CRITICAL_LEVEL.CO_LANH_DAO,
        constants.HC_CASE_PHONGHOP.CRITICAL_LEVEL.KHONG_LANH_DAO
      ],
      item => {
        return {
          value: item,
          name: this.getPhongHopCriticalLevelLabel(item)
        };
      }
    );
  },

  getPhongHopServiceLabel(service) {
    switch (service) {
      case constants.HC_CASE_PHONGHOP.SERVICES.NUOC:
        return "Nước";
      case constants.HC_CASE_PHONGHOP.SERVICES.HOA_QUA:
        return "Hoa quả";
      case constants.HC_CASE_PHONGHOP.SERVICES.MAY_CHIEU:
        return "Máy chiếu";
      case constants.HC_CASE_PHONGHOP.SERVICES.TRUYEN_HINH:
        return "Truyền Hình";
      default:
        return "";
    }
  },

  buildPhongHopServiceOptions() {
    return h.collect(
      [
        constants.HC_CASE_PHONGHOP.SERVICES.NUOC,
        constants.HC_CASE_PHONGHOP.SERVICES.HOA_QUA,
        constants.HC_CASE_PHONGHOP.SERVICES.MAY_CHIEU,
        constants.HC_CASE_PHONGHOP.SERVICES.TRUYEN_HINH
      ],
      item => {
        return {
          value: item,
          name: this.getPhongHopServiceLabel(item)
        };
      }
    );
  },

  //fix issue 1 cuộc họp có thể kéo dài nhiều ngày
  isCrossDay({startTime, endTime}) {
    let startTime_ = moment(startTime);
    let endTime_ = moment(endTime);
    return (
      startTime_.date() !== endTime_.date() ||
      startTime_.month() !== endTime_.month() ||
      startTime_.year() !== endTime_.year()
    );
  },

  //biến đổi về 17:30 cùng ngày
  getEndTimeOfWorkingDay(time) {
    return moment(time)
      .hour(17)
      .minute(30)
      .second(0)
      .millisecond(0)
      .toDate();
  },

  //biến đổi về 17:30 cùng ngày
  getStartTimeOfNextWorkingDay(time) {
    return moment(time)
      .add(1, "day")
      .hour(8)
      .minute(0)
      .second(0)
      .millisecond(0)
      .toDate();
  },

  //tach khoang thoi gian thanh nhung doan tu (8:00 - 17:00);
  splitByDays({startTime, endTime}) {
    let days = [];
    while (startTime < endTime) {
      let endOfDay = this.getEndTimeOfWorkingDay(startTime).getTime();
      days.push({
        startTime: startTime,
        // endTime: Math.min(endOfDay, endTime)
        endTime: dateUtils.isSameDate(endOfDay, endTime) ? endTime : endOfDay
      });
      startTime = this.getStartTimeOfNextWorkingDay(startTime).getTime();
    }
    return days;
  },

  cloneAcceptedRequest(item) {
    return {
      id: item.id,
      title: item.title,
      meetingPlace: item.meetingPlace,
      meetingContent: item.meetingContent,
      chairedUnit: item.chairedUnit,
      leaderNames: item.leaderNames,
      listHcCoopDepts: item.listHcCoopDepts,
      otherInvolved: item.otherInvolved,
      createTime: item.createTime,
      start: item.start,
      end: item.end,
      startTime_: item.startTime_,
      endTime_: item.endTime_,
      isDay: item.isDay,
      caseMasterId: item.caseMasterId,
      hcCaseCalendarId: item.hcCaseCalendarId,
      parentDeptName: item.parentDeptName,
      hcCaseCalendarView: item.hcCaseCalendarView
    };
  },

  initListRequestAccepted2(listRequestAccepted) {
    let listRequestAccepted2 = [];
    h.each(listRequestAccepted, item => {
      let range = {startTime: item.startTime_, endTime: item.endTime_};
      if (this.isCrossDay(range)) {
        h.each(this.splitByDays(range), range_ => {
          let clonedItem = this.cloneAcceptedRequest(item);
          let format = "YYYY-MM-DDTHH:mm:ss";
          clonedItem.start = moment(range_.startTime).format(format);
          clonedItem.end = moment(range_.endTime).format(format);
          clonedItem.isDay = moment(range_.startTime).hour() < 12;
          listRequestAccepted2.push(clonedItem);
        });
      } else {
        listRequestAccepted2.push(item);
      }
    });
    return listRequestAccepted2;
  }
  //fix issue 1 cuộc họp có thể kéo dài nhiều ngày:end
};



// WEBPACK FOOTER //
// ./src/services/hanhChinhUtils.js